import React from 'react'

import { useRouteParams } from '~/hooks/useRouteParams'
import { exists, findByPath } from '~/utils'

import { useCommonQueryBrandAccounts } from './useCommonQueryBrandAccounts'
import { useCommonQueryCurrentSurveysBrandAccount } from './useCommonQueryCurrentSurveysBrandAccount'

export const useCommonQueryCurrentBrandAccount = () => {
  const { brandAccountId } = useRouteParams()

  const brandAccounts = useCommonQueryBrandAccounts()
  const currentSurveyBrandAccount = useCommonQueryCurrentSurveysBrandAccount()

  return React.useMemo(() => {
    const currentBrandAccountId =
      brandAccountId ?? currentSurveyBrandAccount?.brandAccountId

    if (!exists(currentBrandAccountId)) {
      return undefined
    }

    return findByPath(brandAccounts, 'id', currentBrandAccountId)
  }, [brandAccountId, brandAccounts, currentSurveyBrandAccount])
}
